import axios from 'axios';

export const BASE_URL = process.env.REACT_APP_BASEURL;
console.log('API BASE URL:', BASE_URL);
// Helper function to get auth headers
function getAuthHeaders(customHeaders = {}) {
  const accessToken = localStorage.getItem('access_token');
  const tokenType = localStorage.getItem('token_type') || 'Bearer';
  
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
    ...customHeaders,
  };
  
  // Add Authorization header if token exists
  if (accessToken) {
    headers.Authorization = `${tokenType} ${accessToken}`;
  }
  
  return headers;
}


export function listSessions() {
  return axios.get(`${BASE_URL}/agents/list`, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  })
  .then(response => {
    // Response structure: { sessions: [...] }
    return response.data;
  })
  .catch(error => {
    console.error("Error fetching sessions:", error);
    throw error;
  });
}

export function listUserSessions() {
  return axios.get(`${BASE_URL}/sessions/list`, {
    headers: getAuthHeaders(),
  })
  .then(response => response.data)
  .catch(error => {
    console.error("Error fetching user sessions:", error);
    throw error;
  });
}



export function createSession(agentId, sessionName) {
  const payload =
    typeof agentId === "object"
      ? agentId
      : { agent_id: agentId, session_name: sessionName };

  return axios.post(`${BASE_URL}/sessions/create`, payload, {
    headers: getAuthHeaders(),
  });
}


export function uploadDocuments(sessionId, files, voiceGender = "female", includeAudio = true) {
  const formData = new FormData();
  
  // Add files to FormData
  files.forEach((file) => {
    formData.append('files', file);
  });
  
  // Add voice_gender parameter
  if (voiceGender) {
    formData.append('voice_gender', voiceGender);
  }
  
  // Add include_audio parameter
  formData.append('include_audio', includeAudio.toString());

  return axios.post(`${BASE_URL}/sessions/${sessionId}/upload-pdfs`, formData, {
    headers: getAuthHeaders({
      "Content-Type": "multipart/form-data",
    }),
  });
}


export function chatWithSession(sessionId, payload) {
  return axios.post(`${BASE_URL}/sessions/${sessionId}/chat`, payload, {
    // headers: getAuthHeaders(),
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });
}


// Session health (HTTP)
export function getSessionHealth(sessionId) {
  return axios.get(`${BASE_URL}/sessions/${sessionId}/stream/health`, {
    headers: getAuthHeaders(),
  });
}

export async function getSessionHistory(sessionId, limit = 5) {
  try {
    const response = await axios.get(
      `${BASE_URL}/sessions/${sessionId}`,
      {
        params: { limit },
        headers: getAuthHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching session history:", error);
    throw error;
  }
}

// Add this function to your existing api.jsx file

export async function sendSummaryWhatsapp(sessionId, receiverNumber, countryCode) {
  try {
    const response = await axios.post(
      `${BASE_URL}/export/sessions/${sessionId}/send-whatsapp`,
      {
        receiver_number: receiverNumber,
        country_code: countryCode,
      },
      {
        headers: getAuthHeaders(),
      }
    );
    return response;
  } catch (error) {
    console.error("Error sending WhatsApp summary:", error);
    throw error;
  }
}


// Download PDF
export async function downloadSummaryPdf(sessionId) {
  try {
    const response = await axios.get(
      `${BASE_URL}/export/sessions/${sessionId}/download-pdf`,
      {
        responseType: 'blob',
        headers: getAuthHeaders({
          Accept: 'application/pdf',
        }),
      }
    );
    return response;
  } catch (error) {
    console.error("Error downloading PDF:", error);
    throw error;
  }
}

// Download audio
export async function downloadSummaryAudio(sessionId) {
  try {
    const response = await axios.get(
      `${BASE_URL}/export/sessions/${sessionId}/audio`,
      {
        responseType: 'blob',
        headers: getAuthHeaders({
          Accept: 'audio/mpeg',
        }),
      }
    );
    return response;
  } catch (error) {
    console.error("Error downloading audio:", error);
    throw error;
  }
}


export function getSessionDetails(sessionId) {
  return axios.get(`${BASE_URL}/sessions/${sessionId}`, {
    headers: getAuthHeaders(),
  });
}


export function deleteSession(sessionId) {
  return axios.delete(`${BASE_URL}/sessions/${sessionId}`, {
    headers: getAuthHeaders(),
  });
}

// Create a live voice session for audio flow
export function createLiveVoiceSession({
  system_instruction = "",
  response_modality = "AUDIO",
  voice_name = "Aoede",
} = {}) {
  const payload = {
    system_instruction,
    response_modality,
    voice_name,
  };

  return axios.post(`${BASE_URL}/voice/live/sessions/create`, payload, {
    headers: getAuthHeaders(),
  });
}

// End a live voice session
export function endLiveVoiceSession(liveSessionId) {
  return axios.delete(`${BASE_URL}/voice/live/sessions/${liveSessionId}`, {
    headers: getAuthHeaders(),
  });
}

const api = {
  createSession,
  uploadDocuments,
  chatWithSession,
  listSessions,
  getSessionDetails,
  deleteSession,
  createLiveVoiceSession,
  endLiveVoiceSession,
};

export default api;